import React from "react";
import CustomerSvg from "assets/images/customer_service.svg";
import BadgeSvg from "assets/images/business.svg";
import ClockSvg from "assets/images/fast_delivery.svg";
import SuitCaseSvg from "assets/images/guarantee.svg";

export default function QuoteWhatChooseUs({ backgroundCol }) {
  return (
    <section
      className={`${
        backgroundCol ? backgroundCol : "bg-midBlue"
      } pt-24 pb-16 relative`}
    >
      <div className="container mx-auto px-4 lg:w-9/12">
        <div className="">
          <h2 className=" text-[35px] text-center text-white font-secondary font-bold leading-10 uppercase pl-4">
           <span className="text-[#3a7aff]">Why</span>  Choose Us ?
          </h2>
        </div>

        <div className="grid grid-cols-1 place-items-center place-content-center py-8 gap-10 md:grid-cols-2 md:gap-4 md:max-w-xl mx-auto lg:flex lg:flex-row lg:max-w-screen-xl lg:gap-0 lg:space-x-4 lg:items-stretch">
          <div className="bg-darkBlue text-white border border-quotetext-200 rounded-xl text-center px-10 py-12 mx-10 md:mx-0 lg:flex-1">
            <img src={CustomerSvg} alt="loading..." className="m-auto" />

            <h3 className=" text-md py-4 font-semibold font-secondary">
              24/7 Customer Service
            </h3>
            <ul className="text-left list-disc text-sm font-opensans">
              <li>Personal project manager</li>
              <li>Support and assistance via email, phone and chat</li>
            </ul>
          </div>

          <div className="bg-darkBlue text-white border border-quotetext-200 rounded-xl text-center px-10 py-12 mx-10 md:mx-0 lg:flex-1">
            <img src={BadgeSvg} alt="loading..." className="m-auto" />
            <h3 className=" text-md py-4 font-secondary font-semibold">1-year guarantee</h3>
            <ul className="text-left list-disc text-sm font-opensans">
              <li>Post-completion project support</li>
              <li>Comprehensive quality assurance</li>
            </ul>
          </div>

          <div className="bg-darkBlue text-white border border-quotetext-200 rounded-xl text-center px-10 py-12 mx-10 md:mx-0 lg:flex-1">
            <img src={ClockSvg} alt="loading..." className="m-auto" />

            <h3 className=" text-md py-4 font-secondary  font-semibold">Fast Delivery</h3>
            <ul className="text-left  list-disc text-sm font-opensans">
              <li>Availability for urgent orders</li>
              <li>
                Working around the clock to provide the best, fastest service
              </li>
            </ul>
          </div>

          <div className="bg-darkBlue text-white border border-quotetext-200 rounded-xl text-center px-10 py-12 mx-10 md:mx-0 lg:flex-1">
            <img src={SuitCaseSvg} alt="loading..." className="m-auto" />

            <h3 className=" text-md py-4 font-secondary font-semibold">
              95,000 Business Customers
            </h3>
            <ul className="text-left  list-disc text-sm font-opensans">
              <li>Fortune 500 companies trust Tomedes translation agency</li>
              <li>Official and selected Google and Android partner</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
